import { type MouseEvent } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { useVolumeHover } from "~/feature/chart/providers/VolumeHoverProvider";
import { getHoveredIndex } from "~/feature/chart/utils";

export const useVolumeHoverArea = (offsetLeft = 0) => {
  const { timeline } = useCoreChart();
  const { setHoveredIndex } = useVolumeHover();

  const setFromEvent = (event: MouseEvent<HTMLDivElement>) => {
    const { left, width } = event.currentTarget.getBoundingClientRect();

    setHoveredIndex(
      getHoveredIndex(
        event.clientX - left - offsetLeft,
        width - offsetLeft,
        timeline.length
      )
    );
  };

  const onMouseLeave = () => setHoveredIndex(null);

  return {
    onMouseMove: setFromEvent,
    onPointerDown: setFromEvent,
    onMouseLeave,
  };
};
